<p><b>Select — без поиска</b></p>
<div class="box">
  <form [formGroup]="formSelectNoFilter">
    <pa-select
      formControlName="value"
      [options]="cities"
      label="Город"
      placeholder="Выберите город"
      [showFilter]="false"
    ></pa-select>
  </form>
</div>

<p><b>Select — с поиском</b></p>
<div class="box">
  <form [formGroup]="formSelectWithFilter">
    <pa-select
      formControlName="value"
      [options]="cities"
      label="Город с поиском в мобильном режиме"
      placeholder="Выберите город"
      [showFilter]="true"
    ></pa-select>
  </form>
</div>

<p><b>MultiSelect — без поиска</b></p>
<div class="box">
  <form [formGroup]="formMultiNoFilter">
    <pa-multi-select
      formControlName="value"
      [options]="cities"
      label="Города"
      placeholder="Выберите города"
      [showFilter]="false"
    ></pa-multi-select>
  </form>
</div>

<p><b>MultiSelect — с поиском</b></p>
<div class="box">
  <form [formGroup]="formMultiWithFilter">
    <pa-multi-select
      formControlName="value"
      [options]="cities"
      label="Города"
      placeholder="Выберите города"
      [showFilter]="true"
    ></pa-multi-select>
  </form>
</div>

<p><b>Выключенный</b></p>
<div class="box">
  <form [formGroup]="form2">
    <pa-select formControlName="counter" [options]="cities" placeholder="Выберите город"></pa-select>
  </form>
</div>

<p><b>Мультиселект выключенный</b></p>
<div class="box">
  <form [formGroup]="form2Multi">
    <pa-multi-select formControlName="counter" [options]="cities" placeholder="Выберите города"></pa-multi-select>
  </form>
</div>

<p><b>Профи</b></p>
<div class="box">
  <form [formGroup]="form">
    <pa-select formControlName="counter" [options]="cities" label="Выберите город" placeholder="Выберите город" [showProfiTag]="true">
    </pa-select>
  </form>
</div>

<p><b>Подсказки</b></p>
<div class="box">
  <form [formGroup]="form">
    <pa-select
      formControlName="counter"
      [options]="cities"
      label="Выберите город"
      placeholder="Выберите город"
      tooltip="Текст подсказки"
    ></pa-select>
  </form>
</div>

<p><b>Неверный</b></p>
<div class="box">
  <form [formGroup]="form3">
    <pa-select
      formControlName="counter"
      [options]="cities"
      label="Выберите город"
      placeholder="Выберите город"
      [customErrorMessages]="selectErrorMessages"
      hint="Вам нужно выбрать"
    >
    </pa-select>
  </form>
</div>

<p><b>Обычный с кнопкой "Добавить"</b></p>
<div class="box">
  <form [formGroup]="form4">
    <pa-select
      formControlName="city"
      [options]="cities"
      label="Выберите город"
      placeholder="Выберите город"
      [showAddButton]="true"
      (addClick)="handleAddSelect()"
    >
    </pa-select>
  </form>
</div>

<p><b>Мультиселект с кнопкой "Добавить"</b></p>
<div class="box">
  <form [formGroup]="form5">
    <pa-multi-select
      formControlName="cities"
      [options]="cities"
      label="Выберите города"
      placeholder="Выберите города"
      [showAddButton]="true"
      (addClick)="handleAddMultiSelect()"
    >
    </pa-multi-select>
  </form>
</div>

<p><b>Кастомные сообщения ошибок select</b></p>
<div class="box">
  <form [formGroup]="form6">
    <pa-select
      formControlName="cities"
      [options]="cities"
      label="Выберите города"
      placeholder="Выберите города"
      [customErrorMessages]="selectErrorMessages"
    ></pa-select>
  </form>
</div>

<p><b>Кастомные сообщения ошибок multi-select</b></p>
<div class="box">
  <form [formGroup]="form7">
    <pa-multi-select
      formControlName="cities"
      [options]="cities"
      label="Выберите города"
      placeholder="Выберите города"
      [customErrorMessages]="selectErrorMessages"
    ></pa-multi-select>
  </form>
</div>

<p><b>Autocomplete</b></p>
<div class="box">
  <form [formGroup]="form8">
    <pa-autocomplete
      formControlName="city"
      [suggestions]="citiesSuggestions"
      [optionLabel]="'name'"
      label="Город"
      placeholder="Начните вводить"
      (completeMethod)="handleCitySearch($event)"
    ></pa-autocomplete>
  </form>
</div>
